import { Button, Menu, MenuItem, MenuList, Table } from '@mui/material'
import { TableRow } from '@mui/material'
import { TableBody } from '@mui/material'
import { Paper } from '@mui/material'
import { TableCell } from '@mui/material'
import { TableHead } from '@mui/material'
import { TableContainer } from '@mui/material'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { CDRClient, ModifyNumberRequest, PhoneNumberClient, PhoneNumberListClient } from '../../api/server'
import { DatePicker } from '@mui/x-date-pickers'
import { ExtendedClient } from '../../api/ExtendedClient'
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

const InboundCallHistory = () => {
    const [callHistoryRecords, setCallHistoryRecords] = useState([]);
    const [selectedDate, setSelectedDate] = useState('');
    const [isLoading, setIsLoading] = useState(false)
    const globalInfo = useSelector((state) => state.globalInfo)

    const [currentPhoneNumberDigits, setCurrentPhoneNumberDigits] = useState("")
    const [phoneNumbers, setPhoneNumbers] = useState([])
    const [currentPhoneNumberId, setCurrentPhoneNumberId] = useState("")


    function reload() {
        if (!selectedDate) return;
        setIsLoading(true);
        const client = (new ExtendedClient(CDRClient)).getClient();

        client.retrieveCallActionLog(currentPhoneNumberDigits, new Date(selectedDate), new Date(selectedDate)).then((data) => {
            setCallHistoryRecords(data)
            setIsLoading(false);
        })
    }

    function addToLIst(fromPhoneNumer, listType){
        const client = (new ExtendedClient(PhoneNumberListClient)).getClient();

        let request = new ModifyNumberRequest();
        request.number = fromPhoneNumer;
        request.type = listType;
        
        client.addNumber(currentPhoneNumberId, request).then(() => {
            console.log(fromPhoneNumer, listType)
            console.log("done")
        })
    }

    useEffect(() => {
        if (!currentPhoneNumberDigits) {
            const phoneNumberClient = (new ExtendedClient(PhoneNumberClient)).getClient();

            phoneNumberClient.getPhoneNumbers(globalInfo.currentCompanyId).then((data) => {
                setCurrentPhoneNumberDigits(data[0].phoneNumberDigits)
                setCurrentPhoneNumberId(data[0].phoneNumberId)

                setPhoneNumbers(data);

                setSelectedDate(new Date(new Date().toDateString()));
            })

        }
        else {
            reload();
        }

        // eslint-disable-next-line
    }, [globalInfo.currentCompanyId, selectedDate, currentPhoneNumberDigits])


    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
  
    const handleClick = (event) => {
      setAnchorEl(event.currentTarget);
    };
  
    const handleClose = () => {
      setAnchorEl(null);
    };


    return (
        <div>
            <label>Date: </label> <br /><DatePicker onChange={(newValue) => { console.log(new Date(newValue)); setSelectedDate(newValue) }} />
            {
                isLoading && <div>
                    <br />Fetching data...
                </div>
            }
            {
                !isLoading &&
                <>
                    {phoneNumbers.length > 1 && phoneNumbers.map((row) => (
                        <span key={row.phoneNumberId}>
                            <>
                                {
                                    row.phoneNumberId === currentPhoneNumberId && <>
                                        &nbsp; <Button onClick={() => { setCurrentPhoneNumberId(row.phoneNumberId); setCurrentPhoneNumberDigits(row.phoneNumberDigits); }} variant="contained" size="small"> <> {(row.phoneNumberDigits)}</></Button> &nbsp;
                                    </>
                                }
                            </>
                            <>{
                                row.phoneNumberId !== currentPhoneNumberId && <>
                                    &nbsp; <Button onClick={() => { setCurrentPhoneNumberId(row.phoneNumberId); setCurrentPhoneNumberDigits(row.phoneNumberDigits); }} variant="outlined" size="small"><> {(row.phoneNumberDigits)}</></Button> &nbsp;
                                </>
                            }</>
                        </span>
                    )
                    )}
                    <TableContainer component={Paper}>
                        <Table style={{ width: 600 }}>
                        <TableHead>
                                <TableRow>
                                    <TableCell><strong>Caller Number</strong></TableCell>
                                    <TableCell><strong> &nbsp;&nbsp;&nbsp;&nbsp;Call Details</strong></TableCell>
                                    </TableRow>

                            </TableHead>
                            <TableBody>
                                {callHistoryRecords.map((row, index) => (
                                    <TableRow key={row.callSid} >
                                        <TableCell  >
                                            {
                                                row.callerName && <div><strong>{row.callerName}</strong></div>
                                            }
                                            {row.fromPhoneNumer.getFormattedPhoneNum()}
                                            <br></br>
                                   
                                   
                                            <Button
                                                variant="contained"
                                                onClick={handleClick}
                                                endIcon={<ArrowDropDownIcon />} // Adds the down arrow icon
                                                >
                                                Action
                                            </Button>
                                            <Menu
                                                anchorEl={anchorEl}
                                                open={open}
                                                onClose={handleClose}
                                                PaperProps={{
                                                    sx: {
                                                      boxShadow: "0 1px 2px rgba(0, 0, 0, 0.15)", // 1px shadow
                                                      outline: "none",  // Removes the outline
                                                    },
                                                  }}
                                            >
                                                <MenuItem onClick={()=>{handleClose();addToLIst(row.fromPhoneNumer, "priority")}}>Add To Priority List</MenuItem>
                                                <MenuItem onClick={()=>{handleClose();addToLIst(row.fromPhoneNumer, "ignore")}}>Add To Ignore List</MenuItem>
                                                <MenuItem onClick={()=>{handleClose();addToLIst(row.fromPhoneNumer, "hangup")}}>Add To Hangup List</MenuItem>
                                            </Menu>
                                            
                                            
                                        </TableCell>
                                        <TableCell >
                                            <Table>
                                                <TableBody>
                                                    <TableRow>
                                                        <TableCell style={{ width: 150 }}>Received Call at</TableCell>
                                                        <TableCell style={{ textAlign: 'right', width: 150 }}>
                                                            {
                                                                new Date(row.callDateTime.toString()).toLocaleTimeString()
                                                            }
                                                        </TableCell>

                                                    </TableRow>
                                                    {row.callActions.map((action, actionIndex) => (
                                                        <TableRow key={actionIndex}>
                                                            <TableCell style={{ width: 150 }}>Pressed {action.digit} at</TableCell>
                                                            <TableCell style={{ textAlign: 'right', width: 150 }}>
                                                                {
                                                                    new Date(action.digitPressDateTime.toString()).toLocaleTimeString()
                                                                }
                                                            </TableCell>
                                                        </TableRow>

                                                    ))
                                                    }
                                                </TableBody>
                                            </Table>
                                        </TableCell>

                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>

                    </TableContainer>
                </>
            }
        </div>
    )
}

export default InboundCallHistory